/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import {
    changeTemplateTestToManage,
    asyncFetchTemplateTestToManage,
    asyncUpdateTemplateTestToManage,
} from './manage-template-test.actions';

import ManageTemplateTestPresentation from './manage-template-test-presentation';

class ManageTemplateTest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            originalTemplateTest: {},
            labelTest: '',
            maxDuration: 5,
            minOptions: 2,
            maxOptions: 2,
            amountQuestion: 1,
            percentual: 0,
            formReady: false,
            showQuestions: false,
            linkedQuestions: [],
            currentSelects: [],
            questionsAddeds: [],
            questionsRemoveds: [],
        };
    }

    componentDidMount() {
        const { match, asyncFetchTemplateTestToManage } = this.props;
        const testId = match.params.test_id;
        asyncFetchTemplateTestToManage({ testId });
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            labelTest,
            maxDuration,
            percentual,
            amountQuestion,
        } = this.state;
        const { template_test, questions } = this.props;

        if (
            template_test &&
            ((!prevProps.template_test && template_test) ||
                prevProps.template_test.id !== template_test.id)
        ) {
            this.setState({
                originalTemplateTest: template_test,
                labelTest: template_test.label,
                maxDuration: template_test.max_duration / 60,
                minOptions: template_test.min_options,
                maxOptions: template_test.max_options,
                percentual: template_test.approval_percent,
                amountQuestion: template_test.questions_per_test,
            });
        }

        if (prevProps.questions !== questions) {
            const newQuestions = questions.map(question => question.id);
            this.setState({
                linkedQuestions: newQuestions,
                currentSelects: newQuestions,
            });
        }

        if (
            prevState.labelTest !== labelTest ||
            prevState.maxDuration !== maxDuration ||
            prevState.amountQuestion !== amountQuestion ||
            prevState.percentual !== percentual
        ) {
            this.checkForm();
        }
    }

    componentWillUnmount() {
        const { changeTemplateTestToManage } = this.props;
        changeTemplateTestToManage({});
    }

    handleChangeInput(target) {
        this.setState({ [target.name]: target.value });
    }

    checkForm() {
        const {
            labelTest,
            maxDuration,
            percentual,
            amountQuestion,
        } = this.state;

        const formIsOk =
            labelTest !== '' &&
            Number(maxDuration) >= 5 &&
            Number(maxDuration) <= 480 &&
            Number(amountQuestion) >= 1 &&
            Number(amountQuestion) <= 256 &&
            Number(percentual) > 0 &&
            Number(percentual) <= 100;
        this.setState({ formReady: formIsOk });
    }

    handleSubmit(ev) {
        ev.preventDefault();

        const {
            labelTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            questionsAddeds,
            questionsRemoveds,
            amountQuestion,
        } = this.state;
        const { asyncUpdateTemplateTestToManage, match } = this.props;
        const testId = match.params.test_id;

        const maxDurationInSeconds = maxDuration * 60;
        asyncUpdateTemplateTestToManage({
            testId,
            labelTest,
            maxDuration: maxDurationInSeconds,
            minOptions,
            maxOptions,
            percentual,
            amountQuestions: amountQuestion,
            questionsAddeds,
            questionsRemoveds,
        });
    }

    handleShowQuestions(current) {
        this.setState({ showQuestions: !current });
    }

    handleHandleQuestionsAdd(newQuestionsSelecteds) {
        const { linkedQuestions } = this.state;
        const newQuestionsRemoveds = linkedQuestions.filter(
            question => !newQuestionsSelecteds.includes(question),
        );

        const newQuestionsAddeds = newQuestionsSelecteds.filter(
            question => !linkedQuestions.includes(question),
        );

        this.setState({
            questionsAddeds: newQuestionsAddeds,
            questionsRemoveds: newQuestionsRemoveds,
            currentSelects: newQuestionsSelecteds,
        });
    }

    checkDisableQuestionFn(question) {
        const { minOptions, maxOptions } = this.state;
        let questionDisabled = false;
        const amountEnabledItems = question.options.filter(
            option => option.enabled,
        ).length;
        if (
            !questionDisabled &&
            (amountEnabledItems < minOptions || amountEnabledItems > maxOptions)
        ) {
            questionDisabled = true;
        }

        return questionDisabled;
    }

    render() {
        const {
            labelTest,
            maxDuration,
            percentual,
            formReady,
            showQuestions,
            currentSelects,
            questionsAddeds,
            questionsRemoveds,
            amountQuestion,
            minOptions,
            maxOptions,
        } = this.state;
        const { loading } = this.props;

        return (
            <ManageTemplateTestPresentation
                minOptions={minOptions}
                maxOptions={maxOptions}
                labelTest={labelTest}
                maxDuration={maxDuration}
                percentual={percentual}
                amountQuestion={amountQuestion}
                formReady={formReady}
                handleChangeInput={this.handleChangeInput.bind(this)}
                handleSubmit={this.handleSubmit.bind(this)}
                loading={loading}
                showQuestions={showQuestions}
                handleShowQuestions={this.handleShowQuestions.bind(this)}
                handleHandleQuestionsAdd={this.handleHandleQuestionsAdd.bind(
                    this,
                )}
                currentSelects={currentSelects}
                questionsAddeds={questionsAddeds}
                questionsRemoveds={questionsRemoveds}
                checkDisableQuestionFn={this.checkDisableQuestionFn.bind(this)}
            />
        );
    }
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = ({ manageTemplateTest, onlineTests }) => ({
    template_test: manageTemplateTest.template_test,
    loading: onlineTests.loading,
    questions: manageTemplateTest.questions,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            changeTemplateTestToManage,
            asyncFetchTemplateTestToManage,
            asyncUpdateTemplateTestToManage,
        },
        dispatch,
    );

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ManageTemplateTest),
);



// WEBPACK FOOTER //
// ./src/components/manage-template-test/manage-template-test.js